import {
  Amount,
  Summary as Base,
  Chain,
} from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { IToken } from "@sablier/v2-types";
import { useAccount, useChain } from "~/client/hooks";
import type { ComponentProps } from "react";
import Item from "../Item";

interface Props {
  cancelability?: string;
  items: ComponentProps<typeof Item>[];
  token?: IToken;
  size: number;
}

function Summary({ cancelability, items, token, size }: Props) {
  const { isSupported, isMounted } = useAccount();
  const { chain } = useChain();
  const { t } = useT();

  return (
    <Base.Section>
      <Base.Info title={t("words.chain")}>
        {chain && isSupported && isMounted && <Chain id={chain.chainId} />}
      </Base.Info>
      <Base.Info title={t("words.grouping")} value={`Group of ${size}`} />
      <Base.Info title={t("words.cancelability")} value={cancelability} />
      <Base.Info title={_.capitalize(t("words.token"))}>
        <Amount
          empty={"dark600"}
          token={token}
          size={18}
          isFormatted={true}
          isFallbackShown={false}
        />
      </Base.Info>
      <Base.Divider />
      {items.map((item, index) => (
        <Item key={index} {...item} />
      ))}
    </Base.Section>
  );
}

export default Summary;
